export default "__VITE_ASSET__CRKT2tRg__"